import type { NavigationActionCommon, RequireOrgIdOrCloudId } from '../../common/types';
import { isTeamsAppEnabled } from '../../common/utils/is-teams-app-enabled';
import { origin } from '../../common/utils/origin';

import { generateTeamsAppPath } from './generateTeamsAppPath';

export function generatePath(
	path: string,
	config: Pick<NavigationActionCommon, 'hostProduct' | 'userHasNav4Enabled'> &
		RequireOrgIdOrCloudId,
	query: URLSearchParams = new URLSearchParams(),
	anchor?: string,
): string {
	if (isTeamsAppEnabled(config) || config.hostProduct === 'home' || !config.hostProduct) {
		return generateTeamsAppPath(path, config, query, anchor);
	}
	const queryString = [...new Set(query.keys())].length > 0 ? `?${query.toString()}` : '';
	return `${origin()}/${
		config.hostProduct === 'confluence' ? 'wiki' : 'jira'
	}/people/${path}${queryString}`;
}
